import { useEffect, useRef, useCallback } from 'react'

const SCRIPT_ID = 'grecaptcha-v3-script'

function loadRecaptcha(siteKey) {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha?.execute) { resolve(); return }

    let script = document.getElementById(SCRIPT_ID)
    if (!script) {
      script = document.createElement('script')
      script.id    = SCRIPT_ID
      script.src   = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    }
    script.addEventListener('load', () => window.grecaptcha.ready(resolve))
    script.addEventListener('error', reject)
  })
}

/**
 * reCAPTCHA v3 — runs invisibly with no widget or badge interaction.
 * Call execute(action) right before submitting; it resolves with a token.
 * NOTE: the token only proves anything once verified server-side against
 * Google's siteverify endpoint (checking the returned score) — that check
 * does not currently exist in this project's backend.
 */
export function useRecaptcha() {
  const siteKey  = import.meta.env.VITE_RECAPTCHA_SITE_KEY
  const readyRef = useRef(null)

  useEffect(() => {
    readyRef.current = loadRecaptcha(siteKey)
  }, [siteKey])

  const execute = useCallback(async (action = 'submit') => {
    await readyRef.current
    return window.grecaptcha.execute(siteKey, { action })
  }, [siteKey])

  return { execute }
}